import React, {
  Fragment,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react"
import {
  DetailsTrailing,
  LabelBox,
  PercentLabel,
  StyledInput,
  StyledLabel,
  StyledTextFieldFormItem,
} from "./styled"
import MacrosCaloriesPercentWheelPicker from "./MacroCaloriesPercentWheelPicker"
import { IMarcroPercentAndGram } from "features/profile/hooks/manualEditGoal/useManualEditGoalHandlers"
import { formatDisplayNumber, getDisplayCalories } from "utils"

interface IProps {
  label: string
  gram: null | number
  value: null | number
  onChange: (value: IMarcroPercentAndGram) => void
  placeholder?: string
  detailTrailing?: string
  isError?: boolean
  disabled?: boolean

  proteinGram: null | number
  fatGram: null | number
  carbsGram: null | number
  proteinCaloriesPercent: null | number
  fatCaloriesPercent: null | number
  carbsCaloriesPercent: null | number
  calories: null | number
}

const MarcoCaloriesPercentInput = (props: IProps) => {
  const {
    detailTrailing,
    isError = false,
    disabled = false,

    onChange,
    placeholder,
    value,
    label,
    gram,

    proteinGram,
    fatGram,
    carbsGram,
    proteinCaloriesPercent,
    fatCaloriesPercent,
    carbsCaloriesPercent,
    calories,
  } = props

  const [internalValue, setInternalValue] = useState(value?.toString() ?? "")
  const [isPickerOpen, setIsPickerOpen] = useState(false)

  useEffect(() => {
    const hasNumberValue = value !== null && !isNaN(value)
    const isValueChanged = value !== Number(internalValue)

    if (hasNumberValue && isValueChanged) {
      setInternalValue(value.toString())
    }
  }, [value])

  const inputRef = useRef<HTMLInputElement>(null)

  const trailingRef = useRef<HTMLDivElement>(null)
  const [trailingWidth, setTrailWidth] = useState(0)

  useLayoutEffect(() => {
    setTrailWidth(trailingRef.current?.getBoundingClientRect().width ?? 0)
  }, [trailingRef, detailTrailing])

  return (
    <Fragment>
      <MacrosCaloriesPercentWheelPicker
        visible={isPickerOpen}
        onClose={() => setIsPickerOpen(false)}
        onSubmit={(value: IMarcroPercentAndGram) => {
          setIsPickerOpen(false)
          onChange(value)
        }}
        proteinGram={proteinGram}
        fatGram={fatGram}
        carbsGram={carbsGram}
        proteinCaloriesPercent={proteinCaloriesPercent}
        fatCaloriesPercent={fatCaloriesPercent}
        carbsCaloriesPercent={carbsCaloriesPercent}
        calories={calories}
      />

      <StyledTextFieldFormItem
        style={
          {
            "--input-padding-right": "var(--input-padding)",
            "--input-trailing-padding-left": detailTrailing ? "2px" : "0px",
            "--detail-trailing-width": `${trailingWidth}px`,
          } as React.CSSProperties
        }
      >
        <LabelBox>
          <StyledLabel>{label}</StyledLabel>
          <PercentLabel>{formatDisplayNumber(gram ?? 0)} g</PercentLabel>
        </LabelBox>

        <StyledInput
          ref={inputRef}
          readOnly
          $disabled={disabled}
          onFocus={() => {
            setIsPickerOpen(true)
          }}
          $isError={isError}
          placeholder={placeholder}
          value={internalValue ?? ""}
          autoComplete="off"
          style={{
            paddingRight:
              "calc(var(--input-padding-right) + var(--input-trailing-padding-left) + var(--detail-trailing-width))",
          }}
        />
        {detailTrailing && <DetailsTrailing>{detailTrailing}</DetailsTrailing>}

        {detailTrailing && (
          <DetailsTrailing style={{ visibility: "hidden" }} ref={trailingRef}>
            {detailTrailing}
          </DetailsTrailing>
        )}
      </StyledTextFieldFormItem>
    </Fragment>
  )
}

export default MarcoCaloriesPercentInput
